var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var PosAngleData = require("../abstract/posAngleData.js");

var SymbolTerminalData = function (pos, angle, name) {
    var self = this;
    this.makeObservableTreeNode();

    this.addPosAngle(pos, angle);

    this.name = this.value("name", true);   // TODO: reintroduce name manager?

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        function () {
            return new lib_geometry.BoundingBox(this.pos().x-2.5-1, this.pos().y-2.5-1, 1+2.5+10+1.5, 5+1+1).getPoly()
                        .rotate(this.angle(), this.pos());
        },
        [this.pos, this.angle]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function () {
            return self.segmentedGeometry().getBB();
        },
        [this.segmentedGeometry]
    );

    if (name !== undefined) this.name(name);
};
lib_core.mixin(SymbolTerminalData, lib_core.ObservableTreeNode, PosAngleData);
lib_core.JsonParser.registerClass(SymbolTerminalData, "SymbolTerminalData");

module.exports = SymbolTerminalData;